import { AnalyticsChartPeriods } from './analyticsChartPeriods';
import * as _ from "lodash";
import * as moment from 'moment'

export function getGroupedStatsData(stats: any, period: AnalyticsChartPeriods) {
    let groupedTicks = null;

    const getGroupKey = {
        [AnalyticsChartPeriods.Daily]: (ts: number) => {
            const date = moment(ts);
            if (new Date().getFullYear() === date.year()) {
                return moment(ts).format('D MMM');
            }
            return moment(ts).format('D MMM, YYYY');
        },
        [AnalyticsChartPeriods.Weekly]: (ts: number) => {
            const startOfWeek = moment(ts).startOf('isoWeek');
            const endOfWeek = moment(ts).endOf('isoWeek');
            const curYear = new Date().getFullYear();
            if (curYear === startOfWeek.year() && curYear === endOfWeek.year()) {
                if (startOfWeek.month() === endOfWeek.month()) {
                    return startOfWeek.format('MMM D') + '-' + endOfWeek.format('D');
                }
                return startOfWeek.format('MMM D') + '-' + endOfWeek.format('MMM D');
            }
            return startOfWeek.format('MMM D, YYYY') + '-' + endOfWeek.format('MMM D, YYYY');
        },
        [AnalyticsChartPeriods.Monthly]: (ts: number) => {
            return moment(ts).format('MMM, YYYY');
        },
    }

    if (stats && stats.history?.length) {
        const ticksWithGroupKey = stats.history.map(stat => {
            const ts = +stat.timeTs;
            const key = getGroupKey[period](ts);
            return {
                ...stat,
                groupKey: key,
                formattedDate: key,
                date: ts,
            }
        });
        groupedTicks = _.groupBy(ticksWithGroupKey, 'groupKey');
    }
    return groupedTicks;
}

export function getSessionStats(stats: any, period: AnalyticsChartPeriods) {
    let chartData = [];
    let groupedTicks = getGroupedStatsData(stats, period);

    if (!groupedTicks) {
        return {
            chartData: [],
        };
    }

    const tickKeys = Object.keys(groupedTicks);

    if (tickKeys.length > 0) {

        for (let i = 0; i < tickKeys.length; i++) {
            const key = tickKeys[i];
            const groupedData = groupedTicks[tickKeys[i]];
            chartData.push({
                name: key,
                date: groupedData[0].date,
                formattedDate: groupedData[0].formattedDate,
                ...groupedData.reduce((accum, el) => {
                    return {
                        connectedMs: accum.connectedMs + +el.connectedMs,
                        listenMs: accum.listenMs + +el.listenMs
                    }
                }, {
                    connectedMs: 0,
                    listenMs: 0,
                })
            })
        }
    }

    return {
        chartData,
    };
}

export function getRecognizedInteractionsStats(stats: any, period: AnalyticsChartPeriods) {
    let chartData = [];
    let groupedTicks = getGroupedStatsData(stats, period);

    if (!groupedTicks) {
        return {
            chartData: [],
        };
    }

    const tickKeys = Object.keys(groupedTicks);

    if (tickKeys.length > 0) {

        for (let i = 0; i < tickKeys.length; i++) {
            const key = tickKeys[i];
            const groupedData = groupedTicks[tickKeys[i]];
            chartData.push({
                name: key,
                date: groupedData[0].date,
                formattedDate: groupedData[0].formattedDate,
                ...groupedData.reduce((accum, el) => {
                    return {
                        total: accum.total + +el.total,
                        recognized: accum.recognized + +el.recognized
                    }
                }, {
                    total: 0,
                    recognized: 0,
                })
            })
        }
    }

    return {
        chartData,
    };
}

export function getUserSessionsStats(stats: any, period: AnalyticsChartPeriods) {
    let chartData = [];
    let groupedTicks = getGroupedStatsData(stats, period);

    if (!groupedTicks) {
        return {
            chartData: [],
        };
    }

    const tickKeys = Object.keys(groupedTicks);

    if (tickKeys.length > 0) {

        for (let i = 0; i < tickKeys.length; i++) {
            const key = tickKeys[i];
            const groupedData = groupedTicks[tickKeys[i]];
            chartData.push({
                name: key,
                date: groupedData[0].date,
                formattedDate: groupedData[0].formattedDate,
                ...groupedData.reduce((accum, el) => {
                    return {
                        sessionCount: accum.sessionCount + +el.numOfSessions,
                    }
                }, {
                    sessionCount: 0,
                })
            })
        }
    }


    return {
        chartData,
        firstClickEvents: stats.firstClickEvents,
        micAllowedEvents: stats.micAllowedEvents,
    };
}